import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Controle de Acesso (faciais) — permissão POR SEÇÃO: Cadastro · Agenda · Device · Log são
 * quatro rotas de permissão (`/seguranca/controle-acesso/<seção>`, migration 371), cada uma com
 * `admin` próprio no /api/controle-acesso; nenhuma herda da outra. Cada seção é um item do
 * submenu "Controle de Acesso" da sidebar do Hub (config/menu.ts) — não há menu dentro da
 * página. A casca (ControleAcessoPage) é layout fino: cabeçalho da seção (pelo route.name),
 * faixa de alertas do /resumo (um poll só) e a trava de bloqueio em massa.
 *
 * `requiresAdminMaster: true` nas seções NÃO barra ninguém no front (o guard decide pelo nível do
 * /me); é o que o sync de rotas grava no catálogo: a rota segue FECHADA por padrão mesmo num banco
 * em que a 371 não rodou e o sync a criou (aberta, ela daria `member` a todo corporativo).
 */
export const controleAcessoRoutes: RouteRecordRaw[] = [
  {
    path: '/seguranca/controle-acesso',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Controle de Acesso' },
    children: [
      {
        path: '',
        component: () => import('@/views/ControleAcesso/ControleAcessoPage.vue'),
        // As seções são NETAS da rota de layout: sem `syncFilhos` o sync de rotas (um nível) não as
        // manda e o backend as DESATIVA no primeiro login de admin master (ver utils/rotasDoSync).
        meta: { requiresAuth: true, title: 'Controle de Acesso', syncFilhos: true },
        children: [
          { path: '', name: 'ControleAcesso', redirect: { name: 'ControleAcessoCadastro' } },
          { path: 'cadastro', name: 'ControleAcessoCadastro', component: () => import('@/views/ControleAcesso/CadastroPage.vue'), meta: { requiresAuth: true, requiresAdminMaster: true, title: 'Controle de Acesso · Cadastro', breadcrumb: 'Controle de Acesso / Cadastro' } },
          { path: 'agenda', name: 'ControleAcessoAgenda', component: () => import('@/views/ControleAcesso/AgendaPage.vue'), meta: { requiresAuth: true, requiresAdminMaster: true, title: 'Controle de Acesso · Agenda', breadcrumb: 'Controle de Acesso / Agenda' } },
          { path: 'device', name: 'ControleAcessoDevice', component: () => import('@/views/ControleAcesso/DevicePage.vue'), meta: { requiresAuth: true, requiresAdminMaster: true, title: 'Controle de Acesso · Device', breadcrumb: 'Controle de Acesso / Device' } },
          { path: 'log', name: 'ControleAcessoLog', component: () => import('@/views/ControleAcesso/LogPage.vue'), meta: { requiresAuth: true, requiresAdminMaster: true, title: 'Controle de Acesso · Log', breadcrumb: 'Controle de Acesso / Log' } },
        ],
      },
    ],
  },
];
export default controleAcessoRoutes;
